"use strict";
exports.__esModule = true;
exports.defaultRemoteLogisticGroupTypes = exports.defaultInPersonLogisticGroupTypes = exports.LogisticType = exports.LogisticGroupType = void 0;
exports.LogisticGroupType = Object.freeze({
    DressCode: "Dress Code",
    Lunch: "Lunch",
    Parking: "Parking",
    Bikes: "Bikes",
    Laptop: "Laptop",
    Questions: "Questions",
    Travel: "Travel",
    DrinksSnacks: "Drinks & Snacks",
    Bathrooms: "Bathrooms",
    Accessibility: "Accessibility",
    CheckingIn: "Checking In",
    WritingMaterials: "Writing Materials",
    RoomTemp: "Room Temp",
    Pets: "Pets",
    AudioPrep: "Audio Prep",
    RemotePresentation: "Remote Presentation",
    ConnectivityPrep: "Connectivity Prep",
    // Custom overrides for certain customers
    Environment: "Environment"
});
exports.LogisticType = Object.freeze({
    Casual: "Casual",
    BusinessCasual: "Business Casual",
    Business: "Business",
    LunchProvided: "Lunch Provided",
    BreakForLunch: "Break for Lunch",
    ParkingReimbursed: "Parking Reimbursed",
    BikeRoom: "Bike Room",
    BikeRack: "Bike Rack",
    BringYourLaptop: "Bring Your Laptop",
    PrepareYourQuestions: "Prepare Your Questions",
    TravelReimbursed: "Travel Reimbursed",
    Kitchen: "Kitchen",
    GenderNeutralBathrooms: "Gender Neutral Bathrooms",
    WheelchairAccessible: "Wheelchair Accessible",
    LobbySecurity: "Lobby Security",
    FrontDeskCheckin: "Front Desk Checkin",
    PensPaperWhiteboardSupplied: "Pens, Paper, Whiteboard Supplied",
    BringYourNotebook: "Bring Your Notebook",
    OurRoomsRunCold: "Our Rooms Run Cold",
    OurRoomsRunWarm: "Our Rooms Run Warm",
    DogsInTheOffice: "Dogs In The Office",
    Inclusive: "Inclusive",
    DevotedToTheCustomer: "Devoted to the Customer",
    Curious: "Curious",
    Courageous: "Courageous",
    Discerning: "Discerning",
    FindAQuietSpot: "Find a Quiet Spot",
    VideoPrep: "Video Prep",
    WifiConnectivity: "Wifi Connectivity",
    // Custom overrides for certain customers
    GoGreen: "Go Green"
});
exports.defaultInPersonLogisticGroupTypes = [
    exports.LogisticGroupType.DressCode,
    exports.LogisticGroupType.Lunch,
    exports.LogisticGroupType.Parking,
    exports.LogisticGroupType.Bikes,
    exports.LogisticGroupType.Laptop,
    exports.LogisticGroupType.Questions,
    exports.LogisticGroupType.Travel,
    exports.LogisticGroupType.DrinksSnacks,
    exports.LogisticGroupType.Bathrooms,
    exports.LogisticGroupType.Accessibility,
    exports.LogisticGroupType.CheckingIn,
    exports.LogisticGroupType.WritingMaterials,
    exports.LogisticGroupType.RoomTemp,
    exports.LogisticGroupType.Pets,
];
exports.defaultRemoteLogisticGroupTypes = [
    exports.LogisticGroupType.AudioPrep,
    exports.LogisticGroupType.RemotePresentation,
    exports.LogisticGroupType.ConnectivityPrep,
];
//# sourceMappingURL=logistic-module-enums.js.map